import { render } from "./SchedaTecnica.vue?vue&type=template&id=5799a4f2&scoped=true"
import script from "./SchedaTecnica.vue?vue&type=script&lang=js"
export * from "./SchedaTecnica.vue?vue&type=script&lang=js"

import "./SchedaTecnica.vue?vue&type=style&index=0&id=5799a4f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5799a4f2"]])

export default __exports__